import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-success alert-dismissible",
  role: "alert"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Successfully ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "aria-label": "Close"
}, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = {
  key: 0,
  class: "alert alert-success alert-dismissible",
  role: "alert"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Password Changed Sccessfully ! ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "alert",
  "aria-label": "Close"
}, null, -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "alert alert-warning alert-dismissible",
  role: "alert"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Old Password Not Match ! ")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "alert",
  "aria-label": "Close"
}, null, -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "mb-3 form-password-toggle" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-label"
}, "Enter Your Old Password", -1)
const _hoisted_18 = { class: "input-group input-group-merge" }
const _hoisted_19 = ["type"]
const _hoisted_20 = { class: "mb-3 form-password-toggle" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-label"
}, "New Password", -1)
const _hoisted_22 = { class: "input-group input-group-merge" }
const _hoisted_23 = ["type"]
const _hoisted_24 = { class: "mb-3 form-password-toggle" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-label"
}, "Confirm Password", -1)
const _hoisted_26 = { class: "input-group input-group-merge" }
const _hoisted_27 = ["type"]
const _hoisted_28 = { class: "mb-3 mt-3" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 1,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_32 = {
  key: 2,
  class: "visually-show"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.successReport)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      id: "formAuthentication",
      class: "mb-3",
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.setPassword && _ctx.setPassword(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_ctx.actionReport)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
            : _createCommentVNode("", true),
          (_ctx.badactionReport)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _withDirectives(_createElementVNode("input", {
                type: _ctx.showPassword.old ? 'text' : 'password',
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.oldPasswordForm.password) = $event)),
                placeholder: "Enter Old password",
                "aria-describedby": "password"
              }, null, 8, _hoisted_19), [
                [_vModelDynamic, _ctx.oldPasswordForm.password]
              ]),
              _createElementVNode("span", {
                class: "input-group-text cursor-pointer",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.togglePassword('old')))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(_ctx.showPassword.old ? 'bx bx-show' : 'bx bx-hide')
                }, null, 2)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _withDirectives(_createElementVNode("input", {
                type: _ctx.showPassword.new ? 'text' : 'password',
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.setPasswordForm.new_password) = $event)),
                placeholder: "Enter New password",
                "aria-describedby": "password"
              }, null, 8, _hoisted_23), [
                [_vModelDynamic, _ctx.setPasswordForm.new_password]
              ]),
              _createElementVNode("span", {
                class: "input-group-text cursor-pointer",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.togglePassword('new')))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(_ctx.showPassword.new ? 'bx bx-show' : 'bx bx-hide')
                }, null, 2)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _withDirectives(_createElementVNode("input", {
                type: _ctx.showPassword.confirm ? 'text' : 'password',
                id: "password",
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.setPasswordForm.confirm_password) = $event)),
                placeholder: "Confirm New password"
              }, null, 8, _hoisted_27), [
                [_vModelDynamic, _ctx.setPasswordForm.confirm_password]
              ]),
              _createElementVNode("span", {
                class: "input-group-text cursor-pointer",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.togglePassword('confirm')))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(_ctx.showPassword.confirm ? 'bx bx-show' : 'bx bx-hide')
                }, null, 2)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary justify-content-center",
          disabled: _ctx.submitBtn
        }, [
          (!_ctx.submitBtn)
            ? (_openBlock(), _createElementBlock("span", _hoisted_30, "Change Password"))
            : _createCommentVNode("", true),
          (_ctx.submitBtn)
            ? (_openBlock(), _createElementBlock("span", _hoisted_31))
            : _createCommentVNode("", true),
          (_ctx.submitBtn)
            ? (_openBlock(), _createElementBlock("span", _hoisted_32, " Changing...."))
            : _createCommentVNode("", true)
        ], 8, _hoisted_29)
      ])
    ], 32)
  ]))
}